import styled from "styled-components"

const Container = styled.div`
    height: 30px;
    background-color: #006d6dcc;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 300;
    font-family: fantasy;
`

const Announcements = () => {
    return (
        <Container >
            Free Quotes for everyone 
            Just contact us
        </Container>
    )
}

export default Announcements
